// src/i18n/en/durations.ts
// «Tiempos» (mockup 07) — route /durations, Dirección.
export const durations = {
  name: 'Durations |||| Durations',
  subtitle: 'How long guests take in each channel',

  bucketsSwitch: {
    standard: 'Standard',
    fastKiosk: 'Fast kiosk',
  },

  table: {
    title: 'Duration by channel',
    description:
      'Arrivals of the period. Online: the pre-check-in done online, from its start to its completion. Kiosk, Mobile and Air Lobby: from the start of the check-in to its completion on that channel, key delivery not included. With fewer than 20 cases no median, P75 or percentage is shown.',
    columns: {
      channel: 'Channel',
      count: 'Cases',
      medianSeconds: 'Median',
      p75Seconds: 'P75',
      under2MinPct: '< 2 min',
      under5MinPct: '< 5 min',
    },
  },

  ranges: {
    title: 'By duration range',
    description: 'Number of cases of each channel in each range. The ranges follow your «Standard» or «Fast kiosk» preference.',
    labels: {
      '<1m': '< 1 min',
      '1-2m': '1-2 min',
      '2-5m': '2-5 min',
      '5-10m': '5-10 min',
      '>10m': '> 10 min',
      '<30s': '< 30 s',
      '30-60s': '30-60 s',
      '>5m': '> 5 min',
    },
  },

  sections: {
    title: 'Duration by section',
    columns: {
      section: 'Section',
      count: 'Cases',
      medianSeconds: 'Median',
      p75Seconds: 'P75',
    },
  },

  byHour: {
    title: 'By hour of day',
    description: 'Journeys of every channel (dispenser included) by the hotel local hour they started.',
    series: { count: 'This period', previous: 'Previous period' },
  },

  byWeekday: {
    title: 'By day of week',
    description: 'Journeys of every channel (dispenser included) by the hotel local day they started.',
    series: { count: 'This period', previous: 'Previous period' },
    days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
  },

  leadTime: {
    title: 'Lead time: from the start of the pre-check-in to arrival',
    description:
      'Days between the day the guest started the pre-check-in and the arrival date, for arrivals of the period with a finished pre-check-in.',
    medianDays: 'Median: %{days} day |||| Median: %{days} days',
    excludedNegative:
      '%{count} arrival whose pre-check-in started after the arrival date is not included |||| %{count} arrivals whose pre-check-in started after the arrival date are not included',
    buckets: {
      sameDay: 'Same day',
      '1-2d': '1-2 days',
      '3-7d': '3-7 days',
      '>7d': 'More than 7 days',
    },
  },

  help: {
    title: 'Durations',
    description: 'How long guests take to complete pre-check-in and check-in in each channel, and how far ahead they arrive.',
    features: {
      buckets:
        'The ranges table uses the «Standard» or «Fast kiosk» thresholds according to your preference; it is saved to your account and does not affect other users.',
      leadTime: 'Lead time measures the days between the start of the pre-check-in and the arrival date; it is not how long the pre-check-in takes.',
      sample: 'Medians, P75 and percentages need at least 20 cases; below that you will see «Insufficient sample» with the number of cases.',
    },
    tips: {
      medians: 'Medians are shown, not means: a single extreme case does not skew the figure.',
    },
  },
};

export default durations;
